<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
      small
      class="ma-0"
    >
      <v-icon color="error" small>delete</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="error">
        <span class="headline white--text">Unternehmen löschen</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        Möchtest du das Unternehmen "{{company.title}}" wirklich löschen?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="dialog = false">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="del()" :loading="loading">Löschen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  // import { VueEditor } from 'vue2-editor';
  import { mapActions } from 'vuex';

  // TODO: change to typescript and property style

  export default {
    name: 'DlgCompaniesDelete',
    components: {
      // VueEditor,
    },
    data() {
      return {
        dialog: false,
        loading: false,
      };
    },
    props: ['company'],
    methods: {
      ...mapActions({
        companyDel: 'admin/companies/remove',
        companyRead: 'admin/companies/read',
      }),
      del() {
        this.loading = true;
        this.companyDel(this.company)
          .then((res) => {
            this.loading = false;
            if (res) {
              this.companyRead();
              this.dialog = false;
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
